import {
	GET_USER,
	GET_USER_SUCCESS,
	GET_USER_FAILURE,
	CHANGE_AVATAR,
} from './types';

export const getUserAction = () => ({
	type: GET_USER,
});

export const getUserSuccessAction = (payload: any) => ({
	type: GET_USER_SUCCESS,
	payload,
});

export const getUserFailureAction = (error: Error) => ({
	type: GET_USER_FAILURE,
	payload: error,
});

export const changeAvatarAction = (payload: any) => ({
	type: CHANGE_AVATAR,
	payload,
});
